// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  position: relative;
  width: 100%;
  display: flex;
  height: 50vh;
}

.please-wait {
  position: absolute;
  left: 45%;
  top: 60%;
  font-size: 20px;
  color: #551fbd;
  font-family: "Spartan", sans-serif;
}

.circle {
  width: 100px;
  height: 100px;
  border-radius: 100%;
  position: absolute;
  border: 1px solid #a5e300;
  animation: up 1s;
  animation-iteration-count: infinite;
  transition: 2s;
  border-bottom: none;
  border-right: none;
  animation-timing-function: linear;
  margin-left: -70px;
  margin-top: -70px;
  left: 50%;
  top: 50%;
}

@keyframes up {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
#circle2 {
  width: 90px;
  height: 90px;
  left: 50.35%;
  top: 50.7%;
  animation-delay: 0.2s;
}

#circle3 {
  width: 80px;
  height: 80px;
  left: 50.7%;
  top: 51.4%;
  animation-delay: 0.4s;
}

#circle4 {
  width: 70px;
  height: 70px;
  left: 51.05%;
  top: 52.1%;
  animation-delay: 0.6s;
}

#circle5 {
  width: 60px;
  height: 60px;
  left: 51.4%;
  top: 52.8%;
  animation-delay: 0.8s;
}`, "",{"version":3,"sources":["webpack://./src/components/Loader/Loader.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mCAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EACA;IACE,yBAAA;EACF;EACA;IACE,yBAAA;EACF;AACF;AACA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AACF;;AACA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AAEF;;AAAA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AAGF;;AADA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;AAIF","sourcesContent":[".loader-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  height: 50vh;\n}\n\n.please-wait {\n  position: absolute;\n  left: 45%;\n  top: 60%;\n  font-size: 20px;\n  color: #551fbd;\n  font-family: \"Spartan\", sans-serif;\n}\n\n.circle {\n  width: 100px;\n  height: 100px;\n  border-radius: 100%;\n  position: absolute;\n  border: 1px solid #a5e300;\n  animation: up 1s;\n  animation-iteration-count: infinite;\n  transition: 2s;\n  border-bottom: none;\n  border-right: none;\n  animation-timing-function: linear;\n  margin-left: -70px;\n  margin-top: -70px;\n  left: 50%;\n  top: 50%;\n}\n\n@keyframes up {\n  from {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n#circle2 {\n  width: 90px;\n  height: 90px;\n  left: 50.35%;\n  top: 50.7%;\n  animation-delay: 0.2s;\n}\n#circle3 {\n  width: 80px;\n  height: 80px;\n  left: 50.7%;\n  top: 51.4%;\n  animation-delay: 0.4s;\n}\n#circle4 {\n  width: 70px;\n  height: 70px;\n  left: 51.05%;\n  top: 52.1%;\n  animation-delay: 0.6s;\n}\n#circle5 {\n  width: 60px;\n  height: 60px;\n  left: 51.4%;\n  top: 52.8%;\n  animation-delay: 0.8s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
